// extracted by mini-css-extract-plugin
module.exports = {"LifeIcon":"LifeIcon_LifeIcon__2AT37","SizeBig":"LifeIcon_SizeBig__1WN03","ColorGrey":"LifeIcon_ColorGrey__1IlA9"};